import { gql, TypedDocumentNode } from "@apollo/client";

import { RoleView } from "./types";

type RolesData = {
  roles: RoleView[];
};

export const GET_ROLES: TypedDocumentNode<RolesData> = gql`
  query GetRoles {
    roles {
      actions
      description
      id
      isSystem
      name
      roleBindingsCount
      slug
    }
  }
`;
